import logo from './logo.svg';
import './App.css';
import { Design } from './Components/Design';

function App() {
  return (
   <>
   <Design/>
   </>
  );
}

export default App;
